//LIBRARIES
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import camelCase from 'lodash/camelCase';

//HELPERS
import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';

import { FIXED_ADDENDUM, CONDITIONAL_ADDENDUM } from './CreateDocumentTemplateDialog';

const StyledDetailsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
  ${media.mobile`
    width: 100%;
    padding: 8px 10px;
  `};
`;

const StyledSubDetailsContainer = styled.div`
  margin-bottom: 10px;
`;

const StyledArchivedRolesContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;
const StyledHr = styled.hr`
  margin-top: 0px;
`;

const StyledArchivedFilesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledBorder = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  padding: 18px 24px;
  height: 100%;
  width: 100%;
  ${media.mobile`
    padding: 18px 18px;
  `};
`;

const StyledInnerForm = styled.div`
  padding: 10px 20px;
  ${media.mobile`
    padding: 0px 0px;
  `};
`;

const StyledLabel = styled.h4`
  align-self: flex-start;
  margin: 15px 0px;
  font-size: 16px;
  font-weight: 900 !important;
`;

const ArchivedDocumentTemplateDetails = ({
  documentTemplate,
  uploadedFiles,
  documentTemplates,
}) => {
  let baseDocumentTemplateNames = [];
  if (documentTemplate.signable_doc_type === FIXED_ADDENDUM) {
    baseDocumentTemplateNames = documentTemplates
      .filter((docTemp) => documentTemplate.base_document_template_ids.includes(docTemp.id))
      .map((docTemp) => docTemp.title);
  }

  return (
    <StyledDetailsContainer>
      <StyledBorder>
        <StyledInnerForm>
          <StyledLabel style={{ marginTop: '0px' }}>
            {getTranslatedString('landlordPortal.documentTemplateDetailsForm.files')}
          </StyledLabel>
          <StyledArchivedFilesContainer>
            {uploadedFiles.map((file) => {
              return <p key={file.id}>{file.name} </p>;
            })}
          </StyledArchivedFilesContainer>
          <StyledHr />
          <StyledLabel>
            {getTranslatedString('landlordPortal.documentTemplateDetailsForm.description')}
          </StyledLabel>
          <StyledSubDetailsContainer>{documentTemplate.description}</StyledSubDetailsContainer>
          <StyledHr />
          <StyledLabel>
            {getTranslatedString('landlordPortal.documentTemplateDetailsForm.templateType')}
          </StyledLabel>
          <StyledSubDetailsContainer>
            {getTranslatedString(
              `landlordPortal.documentTemplate.${camelCase(documentTemplate.signable_doc_type)}`
            )}
          </StyledSubDetailsContainer>
          <StyledHr />
          {documentTemplate.signable_doc_type === CONDITIONAL_ADDENDUM && (
            <React.Fragment>
              <StyledLabel>
                {getTranslatedString('landlordPortal.documentTemplateDetailsForm.leaseItemType')}
              </StyledLabel>
              <StyledSubDetailsContainer>
                {documentTemplate.conditional_addendum_name}
              </StyledSubDetailsContainer>
            </React.Fragment>
          )}

          {documentTemplate.signable_doc_type === FIXED_ADDENDUM && (
            <React.Fragment>
              <StyledLabel>
                {getTranslatedString(
                  'landlordPortal.documentTemplateDetailsForm.baseDocumentTemplates'
                )}
              </StyledLabel>
              {baseDocumentTemplateNames.map((name) => (
                <StyledSubDetailsContainer>{name}</StyledSubDetailsContainer>
              ))}
            </React.Fragment>
          )}

          <StyledHr />
          <StyledLabel style={{ marginTop: '25px' }}>
            {getTranslatedString('landlordPortal.documentTemplateDetailsForm.roles')}
          </StyledLabel>
          <div>
            <StyledArchivedRolesContainer>
              <p>{getTranslatedString('landlordPortal.documentTemplate.applicants')}</p>
              <p>{documentTemplate.max_num_applicants}</p>
            </StyledArchivedRolesContainer>
            <StyledHr />
            <StyledArchivedRolesContainer>
              <p>{getTranslatedString('landlordPortal.documentTemplate.guarantors')}</p>
              <p>{documentTemplate.max_num_guarantors}</p>
            </StyledArchivedRolesContainer>
            <StyledHr />
            <StyledArchivedRolesContainer>
              <p>{getTranslatedString('landlordPortal.documentTemplate.occupants')}</p>
              <p>{documentTemplate.max_num_occupants}</p>
            </StyledArchivedRolesContainer>
            <StyledHr />
          </div>
          <StyledLabel>
            {getTranslatedString('landlordPortal.documentTemplateDetailsForm.additionalLeaseItems')}
          </StyledLabel>
          <div>
            <StyledArchivedRolesContainer>
              <p>{getTranslatedString('landlordPortal.documentTemplate.rentableItems')}</p>
              <p>{documentTemplate.maximum_rentable_items}</p>
            </StyledArchivedRolesContainer>
            <StyledHr />
            <StyledArchivedRolesContainer>
              <p>{getTranslatedString('landlordPortal.documentTemplate.incentives')}</p>
              <p>{documentTemplate.maximum_incentives}</p>
            </StyledArchivedRolesContainer>
            <StyledHr />
          </div>
        </StyledInnerForm>
      </StyledBorder>
    </StyledDetailsContainer>
  );
};

const mapStoreToProps = (store) => ({
  documentTemplates: store.landlordDocumentTemplates.documentTemplates,
});

const mapDispatchToProps = {};

export default connect(mapStoreToProps, mapDispatchToProps)(ArchivedDocumentTemplateDetails);
